module.exports = __webpack_public_path__ + "img/toman.e0e9f43b.svg";